<template xmlns="http://www.w3.org/1999/html">
    <div class="container">
      <div class="userInfo">
        <el-card class="box-card">
        <div class="tabBox">
        <div class="itemBox">
          <el-table :data="listReview" border style="width: 100%">
            <el-table-column prop="unitName" label="单位名称" align="center">
            </el-table-column>
            <el-table-column prop="entryName" label="项目名称" align="center">
            </el-table-column>

            <el-table-column label="申报类型" align="center">
              <template #default="scope">
                <span>{{ declarationTypeMap[scope.row.declarationType] || '未知类型' }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="createTime" label="创建时间" align="center">
            </el-table-column>
            <el-table-column  label="生成状态" align="center">
              <template #default="scope">
               <span>
             {{ scope.row.templateConnection === null ? '未生成' : '生成完成' }}
             </span>
              </template>
            </el-table-column>
            <el-table-column prop="templateConnection" label="申报项目下载" align="center">
              <template #default="scope">
                <el-button
                    type="primary"
                    size="small"
                    @click="handleDownload(scope.row)"
                >
                  {{'下载' }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
          <el-pagination
              @size-change="handleSizeChangeThree"
              @current-change="handleCurrentChangeThree"
              :page-sizes="[1,10, 20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              class="pageList"/>
        </div>
            <div class="toExistingClass">
            <el-button type="success" @click="toExisting">继续生成</el-button>
            </div>

        </el-card>
      </div>
    </div>
</template>

<script >
import {listApplication, downloadApplicationReport} from "@/api/application";
import {queryViewDetails} from "@/api/login";

export default {
  data() {
    return {
      declarationTypeMap: {
        1: '中央引导地方发展科技资金',
        2: '专项资金申请',
        3: '科小创新能力提升工程',
        4: '山东省重点研发计划',
        5: '鲁渝科技合作项目',
        6: '黄河流域协同科技创新项目',
        7: '泰安市科技创新"双十工程"项目',
      },
      pageSize:10,
      total:0,
      pageNum:1,
      templateConnection:'',
      showUnits: false,
      personaForm: {
        corporateName: '',
        entryName: '',
        projectIntroduction: '',
        cooperativeUnits: [], // 联合申报单位数组
        division: '',//分工
        mainBusiness: '',//主营业务
      },
      listReview:[],
      personaFormNull: {
        corporateName: '',
        entryName: '',
        projectIntroduction: '',
        cooperativeUnits: [], // 联合申报单位数组
        division: '',//分工
        mainBusiness: '',//主营业务
      }
    }
  },
  created() {
    this.getList();
  },

  methods:{

    toExisting(){
      this.$router.push('declaration').then(() => {
        window.location.reload();
      });
    },
    handleSizeChangeThree(val){
      this.pageSize = val;
      var userId = localStorage.getItem("userId");
      if (userId == null) {
        alert("请先登录");
      }
      const data = {
        declarationAccount: userId,
        pageSize:this.pageSize,
        pageNum:this.pageNum,
      }
      listApplication(data).then(response => {
        this.listReview = response.rows
        this.total = response.total
      })

    },
    handleCurrentChangeThree(val){
      this.pageNum = val;
      var userId = localStorage.getItem("userId");
      if (userId == null) {
        alert("请先登录");
      }
      const data = {
        declarationAccount: userId,
        pageSize:this.pageSize,
        pageNum:this.pageNum,
      }
      listApplication(data).then(response => {
        this.listReview = response.rows
        this.total = response.total
      })
    },


    async handleDownload(row) {
      if (!row || !row.templateConnection) {
        this.$message.warning('报告尚未生成，暂不可下载')
        return
      }
      const fileName = (row.entryName || '申报报告') + '.docx'
      try {
        await downloadApplicationReport({
          url: row.templateConnection,
          name: row.entryName || '申报报告'
        }, fileName)
      } catch (e) {
        console.error('申报报告下载失败', e)
      }
    },

    getList(){
      var userId = localStorage.getItem("userId");
      const  param ={
        declarationAccount: userId,
        pageSize:this.pageSize,
        pageNum:this.pageNum,
      }
      listApplication(param).then(res=>{
        if (res.code === 200){
         this.listReview = res.rows;
          this.total = res.total
        }
      })
    }
  }
}
</script>


<style scoped lang="scss">

.toExistingClass{
 text-align:  center;
  margin-top: 30px;
  margin-bottom: 10px;
}

.userInfo {
  margin-bottom: 50px;
}

.container {
  margin: 0 auto;
  padding: 20px;
}

.itemBox {
  position: relative;
  padding: 20px;
  min-height: 250px;
  //height: 400px;
  //overflow-y: auto;
  .item {
    margin-bottom: 20px;
    font-size: 16px;
    .item_info {
      display: flex;
    }
  }
  .empty {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
  }
  .noData {
    width: 200px;
  }
}

.pageList{
  margin-top: 30px;
  /* align-content: center; */
  display: flex;
  justify-content: center;
}
</style>
